<div class="page-title">
  <div [innerHTML]="'SourceOfWealth.Title' | translate | safe:'html'" class="title"></div>
  <div class="sub-title">
    <div [innerHTML]="'SourceOfWealth.SubTitle' | translate | safe:'html'"></div>

    <div class="error-container">
      <ng-container *ngIf="submitted">
        <div *ngIf="!sourceIsValid()" [innerHTML]="'SourceOfWealth.NotComplete' | translate | safe:'html'"
             class="error">
        </div>

        <ng-container *ngIf="sourceIsValid()">
          <div *ngIf="hasZeroSource()" [innerHTML]="'SourceOfWealth.ZeroSource' | translate | safe:'html'"
               class="error">
          </div>

          <div *ngIf="hasEmptyDescription()" [innerHTML]="'SourceOfWealth.EmptyDescription' | translate | safe:'html'"
               class="error">
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<form *ngIf="userModel && userModel.employmentModel" class="source-of-wealth-form">
  <div class="row">
    <div class="col-lg-12 col-xl-5">

      <div class="mobile-progress">

        <img alt="gold" class="gold" src="/img/gold.png">

        <div class="progress-value">{{ this.getSourceSum() }}%</div>
        <div class="progress-background">
          <div
            [ngStyle]="{'width': this.getSourceSum() + '%', 'background': getSourceSum() < 100 ? '#92A0C0' : '#00CC60'}"
            class="progress-fill"></div>
        </div>

        <div class="error-container-mobile">
          <ng-container *ngIf="submitted">
            <div *ngIf="!sourceIsValid()" [innerHTML]="'SourceOfWealth.NotComplete' | translate | safe:'html'"
                 class="error">
            </div>

            <ng-container *ngIf="sourceIsValid()">
              <div *ngIf="hasZeroSource()" [innerHTML]="'SourceOfWealth.ZeroSource' | translate | safe:'html'"
                   class="error">
              </div>

              <div *ngIf="hasEmptyDescription()"
                   [innerHTML]="'SourceOfWealth.EmptyDescription' | translate | safe:'html'"
                   class="error">
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="source-of-wealth-container">
        <div *ngFor="let incomeSource of getIncomeSourceList()" class="source-of-wealth-item">
          <label [ngClass]="{'checked': incomeSource.isSource}" class="source-of-wealth-item-container">
            <input (change)="toggleIncomeSource(incomeSource)" [checked]="incomeSource.isSource"
                   [disabled]="!canToggleIncomeSource(incomeSource)"
                   type="checkbox">
            <span class="checkmark"></span>
            <span class="content">
              <ng-container *ngIf="incomeSource.isSource && navigationService.isMobile">

                <div class="mobile-input-container">
                  <app-percent-input
                    #percentInput
                    (valueChange)="updateUser()"
                    [(value)]="incomeSource.percent"
                    [max]="getSourceMax(incomeSource)"
                    class="percent-input"
                  >
                </app-percent-input>
                  <button (click)="percentInput.onPlusClick()">
                    <svg fill="none" height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.1697 5.07715H7.10801V1.01543C7.10801 0.746121 7.00103 0.487843 6.8106 0.297413C6.62017 0.106983 6.36189 0 6.09258 0C5.82327 0 5.56499 0.106983 5.37456 0.297413C5.18413 0.487843 5.07715 0.746121 5.07715 1.01543V5.07715H1.01543C0.746121 5.07715 0.487843 5.18413 0.297413 5.37456C0.106983 5.56499 0 5.82327 0 6.09258C0 6.36189 0.106983 6.62017 0.297413 6.8106C0.487843 7.00103 0.746121 7.10801 1.01543 7.10801H5.07715V11.1697C5.07715 11.439 5.18413 11.6973 5.37456 11.8877C5.56499 12.0782 5.82327 12.1852 6.09258 12.1852C6.36189 12.1852 6.62017 12.0782 6.8106 11.8877C7.00103 11.6973 7.10801 11.439 7.10801 11.1697V7.10801H11.1697C11.439 7.10801 11.6973 7.00103 11.8877 6.8106C12.0782 6.62017 12.1852 6.36189 12.1852 6.09258C12.1852 5.82327 12.0782 5.56499 11.8877 5.37456C11.6973 5.18413 11.439 5.07715 11.1697 5.07715Z"
    fill="white"/>
</svg>
                  </button>

                  <span>
                    <strong>{{ percentInput.value }}%</strong>
                    {{ getSourceName(incomeSource) | translate }}
                  </span>

                  <button (click)="percentInput.onMinusClick()">
                    <svg fill="none" height="3" viewBox="0 0 13 3" width="13" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.1697 0H1.01543C0.454623 0 0 0.454623 0 1.01543C0 1.57624 0.454623 2.03086 1.01543 2.03086H11.1697C11.7305 2.03086 12.1852 1.57624 12.1852 1.01543C12.1852 0.454623 11.7305 0 11.1697 0Z"
    fill="white"/>
</svg>
                  </button>

                </div>

              </ng-container>
              <ng-container *ngIf="!incomeSource.isSource || !navigationService.isMobile">
                {{ getSourceName(incomeSource) | translate }}
              </ng-container>
            </span>
          </label>

          <app-percent-input
            (valueChange)="updateUser()"
            *ngIf="incomeSource.isSource"
            [(value)]="incomeSource.percent"
            [max]="getSourceMax(incomeSource)"
            class="percent-input"
          >
          </app-percent-input>

          <section *ngIf="requiredDescription(incomeSource)" class="data-field">
            <div class="label">
              {{ 'sourceDescription' | translate }}
            </div>

            <mat-form-field [floatLabel]="'always'" appearance="outline" hideRequiredMarker>
              <input [(ngModel)]="incomeSource.note" matInput name="description"
                     oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')"
                     required>
            </mat-form-field>
          </section>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-xl-7 progress-col">
      <app-circle-progressbar [progress]="getSourceSum()" [radius]="130" class="source-of-wealth-progressbar">
      </app-circle-progressbar>
    </div>
  </div>
</form>
